import React from "react";

export const Eyebrow = ({ children }) => (
  <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-sky-600 mb-3">{children}</span>
);

export const SectionHeader = ({ eyebrow, title, subtitle, center = true, light = false }) => (
  <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} mb-12`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className={`text-3xl sm:text-4xl font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>{title}</h2>
    {subtitle && <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>}
  </div>
);

export const Container = ({ children, className = "" }) => (
  <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);
